import { MEDIA_HM_PATH, ProductFront } from "@project/shared-types";
import { useMemo } from "react";
import { useLocation } from 'react-router';
import { Link } from "../../../../components/link/link";
import { Text } from "../../../../components/texts/text";
import { _colorText, _sizeText } from "../../../../core/core";
import "./SmallService.css";




interface SmallServiceProps {
    service: ProductFront;
}
export const SmallService = (
    { service }: SmallServiceProps
) => {
    const location = useLocation();
    const isCurrent = useMemo(() => {
        if (typeof window !== "undefined") {
            return location.pathname === `/uslugi/${service.service_url}`
        }
        return false
    }, [service.service_url, location.pathname])
    return (
        <Link
            link={`/uslugi/${service.service_url}`}
            is_block
            key={service.id}
            className={`small-service small-service__${isCurrent}`}
        >
            <img src={`${MEDIA_HM_PATH}${service.icon}`} alt={`иконка svg ${service.new_place_name}`} />
            <div className="card-service-hr">
                <Text size={_sizeText.s} color={_colorText.neutral}>{service.new_name}</Text>
                <Text size={_sizeText.sbold}>{service.new_place_name}</Text>
            </div>
        </Link>
    )
}